import {
  StyledNoUpcomingCallBox,
  StyledUpcomingCallsWrapper,
} from "../../../../../../calls/upcoming-calls/upcoming-calls.style";

export function PayoutHistoryEmptyState() {
  return (
    <StyledUpcomingCallsWrapper style={{paddingTop: 0}}>
      <StyledNoUpcomingCallBox>
        <p className="info-text">You do not have any past payouts</p>
      </StyledNoUpcomingCallBox>
    </StyledUpcomingCallsWrapper>
  );
}
